/**
 * /*
 * @author:  caixianglin
 * @createTime: 2017-05-16, 14:12:40 GMT+0800
 */
'use strict';
const config = require('./mapping.config');
//const target = '?debug=true&strictTarget=172.18.24.241:2180';
const target = '';
module.exports = {
    host: config.host,
    api: config.api,
    getTurnplateInfo: config.api + 'vfun/lottery.getBaseInfo/1.0' + target,
    getInteractionInfo: config.api + 'vfun/turnplateLottery.getInteractionInfo/1.0' + target,
    play: config.api + 'vfun/turnplateLottery.play/1.0' + target,
    getWinerCode: config.api + 'vfun/lottery.getWinerCode/1.0' + target,
    getWinerRecord: config.api + 'vfun/winer.getMyRecords/1.0' + target,
    getShare: config.api + 'vfun/vfun.getShare/1.0' + target,
    getShopInfo2: '//wd80.test.weidian.com/shop/service/getPubInfo',
    getShopInfo: '//shop.api.weidian.com/shop/service/getPubInfo',
    getRemainPlayTimes: config.api + 'vfun/lottery.getRemainPlayTimes/1.0',
    myCalculusLink: 'https://vmspub.weidian.com/gaia/9346/ac93327e.html',//我的微积分
    openCalculusLink: config.host + '/m/vpoint-packet/index.html?bizType=406&shopId=',//领取微积分
    getShopId: config.thorHost + 'promotion/vpointpacket.seller.getShopInfo/1.0'//获取微积分相关的shopId
};


/** WEBPACK FOOTER **
 ** ../config/api.config.js
 **/